module.exports = __webpack_public_path__ + "img/poi.5f7d97f0.svg";